import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { EngaugeAiDataComponent } from './engauge-ai-data.component';
import { EngaugeAIService } from 'shared/services/engauge-ai.service';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgxDatatableModule,
        OwlDateTimeModule,
        OwlNativeDateTimeModule
    ],
    declarations: [
        EngaugeAiDataComponent
    ],
    exports: [
        EngaugeAiDataComponent
    ],
    providers: [
        EngaugeAIService
    ]
})
export class EngaugeAiDataModule { }
